import { render, staticRenderFns } from "./TypeBtn.vue?vue&type=template&id=2f5de492"
import script from "./TypeBtn.vue?vue&type=script&lang=js"
export * from "./TypeBtn.vue?vue&type=script&lang=js"
import style0 from "./TypeBtn.vue?vue&type=style&index=0&id=2f5de492&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports